import OfferForm from './OfferForm';

const Offer = props => {
  return (
    <div id="black-offer" className="bg-[#000000] py-[48px]">
      <div className="container">
        <div className="flex lg:flex-row flex-col md:gap-[16px] gap-[48px] items-center">
          <h2 className="md:text-[64px] text-[48px] font-semibold md:leading-[81px] leading-[62px] max-w-[446px] w-full text-white md:pb-[64px]">
            Դիմե՛ք
            <br /> հիմա
          </h2>
          <div className="max-w-[648x] w-full flex-1 relative">
            <OfferForm country={props.country} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
